import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Ensure cookies (JWT) are sent on every request
axios.defaults.withCredentials = true;

/**
 * Prefix a relative /api photo URL with the backend host so <img> tags work.
 * Passes absolute URLs and legacy data: URIs through unchanged.
 */
export const photoUrl = (u) => {
  if (!u) return '';
  if (u.startsWith('data:') || u.startsWith('http://') || u.startsWith('https://')) return u;
  if (u.startsWith('/')) return `${BACKEND_URL}${u}`;
  return u;
};
